<template>
  <div class="relative w-full sm:w-auto">
    <Combobox
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
      v-slot="{ open }"
    >
      <div class="relative w-full sm:w-56">
        <ComboboxInput
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          :class="
            open
              ? 'rounded-t-lg rounded-b-none border-b-gray-200 dark:border-b-gray-700'
              : 'rounded-lg'
          "
          :displayValue="emp => emp?.name || 'Selecteer medewerker...'"
          @change="query = $event.target.value"
          placeholder="Selecteer medewerker..."
        />
        <ComboboxButton class="absolute inset-y-0 right-0 flex items-center pr-3">
          <ChevronUpDownIcon class="h-5 w-5 text-gray-400 dark:text-gray-500" />
        </ComboboxButton>
      </div>
      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ComboboxOptions
          class="absolute z-50 max-h-96 w-full sm:w-56 overflow-auto rounded-b-lg border border-t-0 border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 py-1 shadow-lg focus:outline-none"
        >
          <div
            v-if="filteredEmployees.length === 0"
            class="relative cursor-default select-none py-2 px-4 text-gray-500 dark:text-gray-400 text-sm"
          >
            Geen medewerkers gevonden
          </div>
          <ComboboxOption
            v-for="emp in filteredEmployees"
            :key="emp.simplicate_id"
            :value="emp"
            v-slot="{ active, selected }"
            class="cursor-pointer select-none"
          >
            <div
              :class="[
                active
                  ? 'bg-blue-50 dark:bg-blue-900/50 text-blue-900 dark:text-blue-100'
                  : 'text-gray-900 dark:text-gray-100',
                'relative py-2 pl-3 pr-10 text-sm'
              ]"
            >
              <span :class="[selected ? 'font-semibold' : 'font-normal']">
                {{ emp.name }}
              </span>
              <span
                v-if="emp.action_count"
                class="ml-2 px-1.5 py-0.5 text-xs rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300"
              >
                {{ emp.action_count }}
              </span>
              <span
                v-if="selected"
                class="absolute inset-y-0 right-0 flex items-center pr-3 text-blue-600"
              >
                <CheckIcon class="h-4 w-4" />
              </span>
            </div>
          </ComboboxOption>
        </ComboboxOptions>
      </transition>
    </Combobox>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption
} from '@headlessui/vue'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/vue/24/outline'

const ALL_OPTION = { simplicate_id: '__ALL__', name: 'Alles' }

const props = defineProps({
  modelValue: { type: Object, default: null },
  employees: { type: Array, required: true }
})

defineEmits(['update:modelValue'])

const query = ref('')

// Filtered employees based on search query (includes "Alles" option at top)
const filteredEmployees = computed(() => {
  const allEmployees = [ALL_OPTION, ...props.employees]
  if (query.value === '') {
    return allEmployees
  }
  const q = query.value.toLowerCase()
  return allEmployees.filter(emp => emp.name.toLowerCase().includes(q))
})
</script>
